import Blog01 from "./Blog01";
import Contact from "./Contact";
import AboutUs from "./About-us";
import Dashboard from "./Dashboard";
import Explore04 from "./Explore04";
import Faqs from "./Faqs";
import HelpCenter from "./HelpCenter";
import Home03 from "./Home03";
import HomeNew from "./HomeNew";
import Login from "./Login";
import SignUp from "./SignUp";
import Policies from "./Policies";
import Cart from "./Cart";
import Checkout from "./Checkout";
import ProtectedRoute from "../components/ProtectedRoute";

const routes = [
  { path: '/', component: <HomeNew />},
  { path: '/home-old', component: <Home03 />},
  { path: '/dt-shop', component: <Explore04 />},
  { path: '/dashboard', component: <ProtectedRoute><Dashboard /></ProtectedRoute>},
  { path: '/help-center', component: <HelpCenter />},
  { path: '/faqs', component: <Faqs />},
  { path: '/policies', component: <Policies />},
  { path: '/login', component: <Login />},
  { path: '/signup', component: <SignUp />},
  { path: '/about-us', component: <AboutUs />},
  { path: '/cart', component: <Cart />},
  { path: '/checkout', component: <Checkout />},
  { path: '/blog', component: <Blog01 />},
  { path: '/contact', component: <Contact />},
]

export default routes;